import { render, staticRenderFns } from "./PageStackDetail.vue?vue&type=template&id=b55f0e82&scoped=true&"
import script from "./PageStackDetail.vue?vue&type=script&lang=js&"
export * from "./PageStackDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageStackDetail.vue?vue&type=style&index=0&id=b55f0e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55f0e82",
  null
  
)

export default component.exports